import { useEffect, useState } from 'react';

const useMicrophone = (): {
  track: MediaStreamTrack | null;
  error: DOMException | null;
  start: () => void;
  stop: () => void;
} => {
  const [ trackPromise, setTrackPromise ] = useState<Promise<MediaStreamTrack | null> | null>(null);
  const [ error, setError ] = useState<DOMException | null>(null);
  const [ track, setTrack ] = useState<MediaStreamTrack | null>(null);

  const start = () => {
    const trackPromise = navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    }).then((stream) => {
      setError(null);

      return stream.getAudioTracks()[0];
    }).catch((error: DOMException) => {
      setError(error);

      return null;
    });
    setTrackPromise(trackPromise);
  };

  const stop = () => {
    setTrackPromise(null);
  };

  useEffect(() => {
    if (trackPromise !== null) {
      trackPromise.then((track) => {
        setTrack(track);

        if (track !== null) {
          track.addEventListener('ended', () => {
            setTrackPromise(null);
          });
        }
      });

      return () => {
        trackPromise.then((track) => {
          if (track !== null) {
            track.stop();
          }
        });
      };
    } else {
      setTrack(null);
    }
  }, [ trackPromise ]);

  return {
    track,
    error,
    start,
    stop,
  };
};

export default useMicrophone;
